import { useLocation } from "react-router-dom";
import ProfileDropdown from "./ProfileDropdown";

function MenuIcon() {
  return (
    <svg viewBox="0 0 24 24">
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  );
}

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <path d="m16.5 16.5 4 4" />
    </svg>
  );
}

function BellIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );
}

const pageTitles = {
  "/dashboard": "Performance Overview",
  "/calls": "Calls",
  "/analytics": "Analytics",
  "/lead-management": "Contacts / Leads",
  "/appointments": "Appointments",
  "/campaigns": "Campaigns",
  "/team-management": "Team Management",
  "/settings": "Settings",
};

export default function Header({
  onToggleSidebar,
  onOpenSearch,
  liveSummary,
  liveStatusError,
  notificationsOpen,
  notificationCount = 0,
  onToggleNotifications,
  notificationsPanel,
}) {
  const { pathname } = useLocation();
  const pageTitle = pageTitles[pathname] || "Nexora Calling";
  const activeCalls = Number(liveSummary?.active || 0);
  const liveLabel = liveStatusError
    ? "Active Calls --"
    : `${activeCalls} Active Call${activeCalls === 1 ? "" : "s"}`;
  const liveState = liveStatusError
    ? "is-error"
    : activeCalls > 0
      ? "is-live"
      : "is-quiet";

  return (
    <header className="header">
      <div className="header-brand">
        <button
          type="button"
          className="menu-toggle-btn"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation"
        >
          <MenuIcon />
        </button>
        <div className="header-title">{pageTitle}</div>
      </div>
      <div className="header-right">
        <button
          type="button"
          className="header-icon-btn"
          aria-label="Search (Ctrl K)"
          title="Search - Ctrl K"
          onClick={() => onOpenSearch?.("")}
        >
          <SearchIcon />
        </button>
        <div className={`live-badge ${liveState}`} aria-label="Live system status">
          <span className="live-dot" />
          <span>{liveLabel}</span>
        </div>
        <div className="notifications-anchor">
          <button
            type="button"
            className={`header-icon-btn${notificationsOpen ? " is-active" : ""}`}
            aria-label="Open notifications"
            aria-expanded={notificationsOpen}
            onClick={onToggleNotifications}
          >
            <BellIcon />
            {notificationCount > 0 ? (
              <span className="notification-count">
                {notificationCount > 99 ? "99+" : notificationCount}
              </span>
            ) : null}
          </button>
          {notificationsPanel}
        </div>
        <ProfileDropdown />
      </div>
    </header>
  );
}
